'use client'

/** One footer design and content source for every public page. */
export { PublicSiteFooter as SiteFooter } from './chrome/public-site-chrome'
export { collectionSlugFromHref, keepIndexedCollectionLinks } from '@/lib/chrome-link-gate'
